import { render, staticRenderFns } from "./vipManagement.vue?vue&type=template&id=6aa32d6a&scoped=true"
import script from "./vipManagement.vue?vue&type=script&lang=ts"
export * from "./vipManagement.vue?vue&type=script&lang=ts"
import style0 from "./vipManagement.vue?vue&type=style&index=0&id=6aa32d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa32d6a",
  null
  
)

export default component.exports